export { default } from "~/components/promotionLinks/PromotionsLinks"

export function LoadingFallback() {
  return <div className='w-full aspect-[412/426] lg:aspect-[1903/293] bg-gray-200 animate-pulse' />
}
